import React, { useState, useEffect } from 'react'
import Select from 'react-select'

import gql from 'graphql-tag'

import { find as _find } from 'lodash'
import { useQuery } from "@apollo/react-hooks";
import { FormGroup, Label} from 'reactstrap'

const query = gql`
  query Provinces($where: ProvinceWhereInput) {
    provinces(where: $where) {
      id
      name
    }
  }
`

export const ProvinceSelect = ({ item, onSelect, selectProps = {} }) => {
  const [values, setValues] = useState([])
  const [selected, setSelected] = useState({})

  const { data, loading } = useQuery(query);

  useEffect(() => {
    if (!loading && data) {
      setValues((data.provinces || []).map(value => ({
        label: value.name,
        value
      })));
    }
  }, [loading, data]);

  useEffect(() => {
    setSelected(_find(values, ({ value })=> (value.id === (item || {}).id)))
  }, [item, values])

  const onChange = (vItem) => {
    setSelected(vItem)
    onSelect(vItem.value)
  }

  return (
    <>
      <FormGroup>
        <Label>Provincia</Label>

        <Select
          classNamePrefix="dhn-select"
          value={selected || null}
          options={values}
          isLoading={loading}
          placeholder='Selecciona una provincia'
          onChange={onChange}
          {...selectProps}
        />
      </FormGroup>
    </>
  )
}
